/*
 * @Author: 肖玲
 * @Date: 2023-03-02 18:30:56
 * @LastEditTime: 2024-03-19 17:47:17
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\system-settings\modules\collectionLogRouter.js
 * 采集日志
 */
const collectionLogRouter = [
  // 流向上传记录
  {
    path: '/flowSystem/flow-upload-record',
    name: 'flowSystemFlowRecord',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemFlowReport" */
        '@/views/butterfly-flow-system/system-settings/collect-log/flow-record/Page.vue'
      ),
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '流向上传记录'
    }
  },
  // 流向上传报告
  {
    path: '/flowSystem/flow-report',
    name: 'flowSystemFlowReport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemFlowReport" */
      //   '../views/flowSystem/FlowReport.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemFlowReport" */
        '@/views/butterfly-flow-system/system-settings/collect-log/flow-upload/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '流向上传报告'
    }
  },
  // 流向报告 - 销售月报上传报告 type:判断月报还是日报
  {
    path: '/flowSystem/market-monthly/:json/:meta_type/:type',
    name: 'flowSystemMarketMonthly',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemMarketMonthly" */
      //   '../views/flowSystem/MarketMonthly.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemMarketMonthly" */
        '@/views/butterfly-flow-system/system-settings/collect-log/flow-upload/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      isMoreMeta: true,
      1: {
        title: '销售月报上传报告',
        breadcrumb: [
          {
            title: '流向报告',
            name: 'flowSystemFlowReport'
          }
        ]
      },
      3: {
        title: '采购月报上传报告',
        breadcrumb: [
          {
            title: '流向报告',
            name: 'flowSystemFlowReport'
          }
        ]
      },
      2: {
        title: '库存日报上传报告',
        breadcrumb: [
          {
            title: '流向报告',
            name: 'flowSystemFlowReport'
          }
        ]
      }
    }
  },
  // 数据采集日志
  {
    path: '/flowSystem/direct-log',
    name: 'flowSystemDirectLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/DirectLog.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/data-collection-log/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '数据采集日志'
    }
  },
  // 商业采集进度
  {
    path: '/flowSystem/collection-progress',
    name: 'flowSystemCollectionProgress',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-progress/list.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '商业采集进度'
    }
  },
  // 商业采集进度/特殊商业
  {
    path: '/flowSystem/collection-progress-specialTrade',
    name: 'flowSystemCollectionProgressSpecialTrade',
    component: () =>
      import(
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/specialTrade.vue'
      ),
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '商业采集进度'
    }
  },
  // 商业采集监控
  {
    path: '/flowSystem/commercial-collection-monitor',
    name: 'flowSystemCommercialCollectionMonitor',
    component: () =>
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-collection-monitor/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '商业采集监控'
    }
  },
  // 商业采集监控 日报
  {
    path: '/flowSystem/commercial-collection-monitor/day',
    name: 'flowSystemCommercialCollectionMonitorDay',
    component: () =>
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-collection-monitor-day/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '商业采集监控-日报'
    }
  },
  // 商业采集进度 批量导入
  {
    path: '/flowSystem/collection-trouble/import',
    name: 'flowSystemCollectionTroubleImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-trouble/Import.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/BatchImport.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集问题处理', //二级菜单
      title: '批量导入',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        },
        {
          title: '采集问题处理',
          name: 'flowSystemCollectionTrouble'
        }
      ]
    }
  },
  // 商业采集进度 批量流转
  {
    path: '/flowSystem/collection-trouble/batchCirculation',
    name: 'flowSystemBatchCirculation',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-trouble/Import.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/BatchCirculation.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '商业采集进度', //二级菜单
      title: '批量流转',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        }
      ]
    }
  },
  // 商业采集进度 采集问题处理 处理进度详情
  {
    path: '/flowSystem/collection-trouble-progress/details/:collect_subsequent_id',
    name: 'flowSystemCollectionTroubleProgressDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-trouble/Detail.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/ViewProgress.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '查看进度',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        },
        {
          title: '采集问题处理',
          name: 'flowSystemCollectionTrouble'
        }
      ]
    }
  },
  // 商业采集进度 详情
  {
    path: '/flowSystem/collection-progress/details/:collect_client_id',
    name: 'flowSystemCollectionProgressDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-progress/details.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '查看进度',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        }
      ]
    }
  },
  // 商业采集进度 采集问题处理 处理进度详情 查看更多
  {
    path: '/flowSystem/collection-trouble-progress/record-list/:collect_subsequent_id/:clientName',
    name: 'flowSystemCollectionTroubleProgressRecordList',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-trouble/RecordList.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/CollectionProblemDetail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '查看进度',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        },
        {
          title: '采集问题处理',
          name: 'flowSystemCollectionTrouble'
        }
      ]
    }
  },
  // 商业采集进度 详情 采集记录
  {
    path: '/flowSystem/collection-progress/record-list/:collect_client_id',
    name: 'flowSystemCollectionProgressRecordList',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-progress/recordList.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/CollectRecord.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '查看更多',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        },
        {
          title: '查看进度',
          name: 'flowSystemCollectionProgressDetails'
        }
      ]
    }
  },
  // 商业采集进度 操作日志
  {
    path: '/flowSystem/collection-progress/log',
    name: 'flowSystemCollectionProgressLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-progress/log.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/OperationLog.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '操作日志',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        }
      ]
    }
  },
  // 商业采集问题处理 操作日志
  {
    path: '/flowSystem/collection-trouble-progress/log',
    name: 'flowSystemCollectionTroubleProgressLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-trouble/log.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/ProblemLog.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '操作日志',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        },
        {
          title: '采集问题处理',
          name: 'flowSystemCollectionTrouble'
        }
      ]
    }
  },
  // 同步数据核验设置
  {
    path: '/flowSystem/collection-progress/sync-set',
    name: 'flowSystemCollectionProgressSyncSet',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-progress/SyncSet.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/SyncSetting.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '同步数据核验设置',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        }
      ]
    }
  },
  // 商业采集进度 导入
  {
    path: '/flowSystem/collection-progress/import/:is_old',
    name: 'flowSystemCollectionProgressImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-progress/import.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/Import.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '导入采集信息',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        }
      ]
    }
  },
  // 商业采集进度 积存数据导入
  {
    path: '/flowSystem/collection-progress/cumulative-data-import',
    name: 'flowSystemCollectionProgressCumulativeDataImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-progress/CumulativeDataImport.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/PurchaseDataImport.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '积存数据导入',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        }
      ]
    }
  },
  // 商业采集进度 编辑
  {
    path: '/flowSystem/collection-progress/edit/:collect_client_id/:company_id/:collect_status/:is_success/:collect_status_id/:collect_name',
    name: 'flowSystemCollectionProgressEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-progress/edit.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/Edit.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        }
      ]
    }
  },
  // 商业采集进度 详情 更新采集进度信息
  {
    path: '/flowSystem/collection-progress/upload-data/:collect_client_id',
    name: 'flowSystemCollectionProgressUploadData',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/collection-progress/uploadData.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/collect-log/commercial-acquisition-progress/Update.vue'
      ),
    meta: {
      SecondaryMenu: '采集日志', //二级菜单
      title: '更新采集进度信息',
      breadcrumb: [
        {
          title: '商业采集进度',
          name: 'flowSystemCollectionProgress'
        },
        {
          title: '查看进度',
          name: 'flowSystemCollectionProgressDetails'
        }
      ]
    }
  }
]
export default collectionLogRouter
